/*
 *   File : service.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : global function for API calls using axios
 *   Integrations : axios, jwt-encode, jwt-decode
 *   Version : v1.1
 */

import axios from 'axios';
import sign from 'jwt-encode';
import { jwtDecode } from 'jwt-decode';
import CONSTANTS from "../config";
import { clearDatadogUser } from "../datadog";

let jwt_secret_key = CONSTANTS.JWT_SECRET_KEY;
const service = async function (isGet, api, params, token, byPass = false, rawBlob = false) {
    try {
        const API_URL = CONSTANTS.apiBaseUrl + api;
        let headers = {
            'Content-Type': 'application/json',
        };

        if (token) {
            headers['Access-Token'] = token;
        }

        if (isGet) {
            // GET request
            return await axios.get(API_URL, {
                headers: headers,
                timeout: 30000  // 30s — long enough for slow endpoints, short enough that users don't stare at a spinner forever
            })
                .then(async (response) => {
                    const parsed_data = response.data;
                    const decoded = await jwtDecode(parsed_data, jwt_secret_key, { skipValidation: false })
                    return decoded
                })
                .catch((error) => handleAxiosError(error));
        } else {
            // POST request
            let converted_params = { ...params };
            if (Object.values(params).includes(null)) {
                Object.keys(params).forEach(key => {
                    if (params[key] === null) {
                        converted_params[key] = '&?';
                    }
                });
            }

            const body = sign(converted_params, jwt_secret_key, { alg: 'HS256' });

            // For axios 1.x: Send the JWT string directly without auto-stringification
            return await axios.post(API_URL, body, {
                headers: headers,
                timeout: 30000,  // 30s — long enough for slow endpoints, short enough that users don't stare at a spinner forever
                responseType: rawBlob ? 'blob' : 'json',
                transformRequest: [(data) => {
                    // If data is already a string (JWT), return it as-is
                    // This prevents axios 1.x from JSON.stringify-ing it again
                    if (typeof data === 'string') {
                        return data;
                    }
                    return data;
                }]
            })
                .then(async (response) => {
                    if (rawBlob) return response; // ⬅️ Don't decode Blob
                    const parsed_data = response.data;
                    const decoded = await jwtDecode(parsed_data, jwt_secret_key, { skipValidation: false });
                    return decoded;
                })
                .catch((error) => handleAxiosError(error));
        }
    } catch (err) {
        console.error(api, 'API error ::', err);
        return {
            status: false,
            message: "We are facing a server outage error now. Please try later or contact our support team.",
            status_code: 400
        };
    }
};

// Error handler for axios
const handleAxiosError = async (error) => {
    console.error('Axios error:', error);
    if (error.response && error.response.data) {
        try {
            let parsed_error = error.response.data;
            const decoded = await jwtDecode(parsed_error, jwt_secret_key, { skipValidation: false })
            if (decoded.status_code === 446 || decoded.status_code === 401) {
                clearDatadogUser();
                sessionStorage.clear();
                window.location.href = "/";
            }
            return decoded

        } catch (parseError) {
            return {
                status: false,
                message: "Invalid response from server",
                status_code: 400
            };
        }
    }
    return {
        status: false,
        message: "Request failed. Please try later.",
        status_code: 400
    };
};

export default service;
